import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { makeSelectCategories } from "containers/App/selectors";

const RewardsPage = ({ categories, children }) => {
  if (!categories) {
    return <div></div>;
  }
  return <div>{children}</div>;
};

RewardsPage.propTypes = {
  categories: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  children: PropTypes.node,
};

const mapStateToProps = createStructuredSelector({
  categories: makeSelectCategories(),
});

export default connect(mapStateToProps)(RewardsPage);
